import { getAPIUrl } from '../API'
export interface UserInfo {
  customerId: 0
  subscriberId: 0
  logo: string
  firstName: string
  surname: string
  idNumber: string
  telephone: string
  fax: string
  cell: string
  email: string
  username: string
  isActive: string
  isAdmin: string
  doPermTitleDeed: string
  doPermTelNum: string
  doPermTelNumSub: string
  doPermDeedsOffice: string
  doPermDeedsOfficeSub: string
  startDate: string
  endDate: string
  notes: string
  lastAccess: string
  loggedIn: string
  dualLogins: string
  branchAdmin: string
  dualSince: string
  dualLoginsSince: string
  lockedUntil: string
  accountExpires: string
  subscriberName: string
}
export const getUserInfo = async () => {
  try {
    const result = await fetch(getAPIUrl() + '/User/userdetails', {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + sessionStorage.getItem('jwt'),
      },
    })

    if (result.ok) {
      const data = await result.json()
      return data.data as UserInfo
    }

    throw new Error('Failed to fetch user info.')
  } catch (error) {
    console.error('Error occurred while fetching user info:', error)
    throw error
  }
}
